"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("components");
const utils_1 = require("utils");
const OfferCard_1 = __importDefault(require("../components/OfferCard"));
function MoreOffers({ offers }) {
    (0, react_1.useEffect)(() => {
        (0, utils_1.scrollToTop)();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "offers-container", style: { paddingTop: '20px' }, children: [(0, jsx_runtime_1.jsx)(components_1.H1, { className: "mar-t-20", children: "Let\u2019s take a look at the other offers." }), (0, jsx_runtime_1.jsx)(components_1.H2, { className: "mar-t-40", children: "Please see below your Alphaeon offer details" }), (0, jsx_runtime_1.jsx)("div", { className: "mar-t-40", children: offers.map((offer) => ((0, jsx_runtime_1.jsx)(OfferCard_1.default, { offer: offer }, offer.offerId))) }), offers.some((offer) => offer.offerType === 'prequalified' &&
                offer.serviceProviderName === 'ADS') && ((0, jsx_runtime_1.jsx)("div", { className: "mar-t-40", children: (0, jsx_runtime_1.jsx)(components_1.P, { className: "color-gray", children: "* The credit limit provided is based on your pre-qualification only, and upon submission of your full credit application, may be increased or decreased." }) }))] }));
}
exports.default = MoreOffers;
